//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect,useRef } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "./styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";
import Tier from "assets/img/Tier.JPG";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
// material-ui icons

const ReviewTextField = withStyles({
  root: {
    width: "30%",
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#1473e6",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#1473e6",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 5,
        padding: "12px 16px !important",
        fontSize: "14px !important",
        lineHeight: "22px",
        color: "#0f1d40",
      },
    },
  },
})(TextField);

export default function ThriveSignatureEnrollmentForm() {

  const classes = consentStyles();
  const location = useLocation();
  const history = useHistory();
  const { t } = useTranslation();
  const param = new URLSearchParams(location.search);
  const token = param.get("token");
  const [states, setstates] = useState({
    tier:'',
 
  });
console.log(states.tier)


  return (
    <div>
   
</div>
    
  );
}